import { useTeams } from "@/contexts/teams-provider";

/**
 * Whether the selected team may see the key contacts — employees,
 * key contacts, LinkedIn key executives (#757, narrowed by #840). The
 * registry's people (directors, mandates, BODACC notices) are always shown.
 *
 * Read from the team's contact switch alone; cutting it also closes the email
 * and phone channels, server-side. False while the team is loading, so a cut
 * team never sees those people flash in.
 */
export function useArePeopleVisible(): boolean {
  const { teamSelected } = useTeams();
  if (!teamSelected) return false;
  return teamSelected.featureContactDirectEnabled;
}
